module.exports = __webpack_public_path__ + "static/media/quiz-artistico.9a6a49f5.png";